import React from "react";
import moment from 'moment'
import 'moment-timezone';
import { tzCodeToIANA } from "../../Utils";
import { formatPhoneNumber, formatSSN } from "./NTTCReview";

interface PatientHeaderProps {
  Facility?: { FriendlyName: string, StationNo: string, VisnNo: string };
  LastName?: string;
  FirstName?: string;
  PatientSSN?: string;
  PatientCell?: string;
  ts_Appointment?: string;
  psfsElements?: any;
  form: any;
  stepManuallyChanged?: boolean;
}

const PatientHeader: React.FC<PatientHeaderProps> = ({
  psfsElements,
  form,
  stepManuallyChanged
}) => {
  const facility = psfsElements?.Facilities?.find((facility: any) => facility._key === form.fk_Facility);

  const patientInfo = {
    FacilityName: facility?.FriendlyName ?? 'Unknown Facility',
    VisnNo: facility?.VisnNo ?? 'Unknown Visn',
    SiteCode: facility?.SiteCode ?? 'Unknown Site',
    LastName: form?.LastName ?? 'Unknown',
    FirstName: form?.FirstName ?? 'Unknown',
    PatientSSN: (form?.FullSSN?.trim() || form?.PatientSSN?.trim()) || 'Unknown',
    PatientDOB: form?.PatientDOB ?? 'Unknown',
    PatientCell: form?.PatientCell ?? form?.PatientCellNumber ?? 'Unknown',
    ts_Appointment: form?.ts_Appointment ?? 'Unknown'
  }

  const formatDOB = (dob: any) => {
    if (!dob || dob === 'Unknown' || !moment(dob).isValid()) return 'Unknown';
    return moment(dob).format('MM/DD/YYYY');
  };

  const formatCell = (cell: any) => {
    if (!cell || cell === 'Unknown') return 'Unknown';
    return formatPhoneNumber(cell);
  };

  return (
    <div className="patient-info-box">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        {/* Left side - Patient details */}
        <div className="patient-info-row m-1">
          <span className="patient-info-item"><span className="label">Facility :</span> <span className="value"> {patientInfo.FacilityName} ({patientInfo.VisnNo}/{patientInfo.SiteCode})</span></span>
          <span className="patient-info-item"><span className="label">Last Name:</span> <span className="value">{patientInfo.LastName}</span></span>
          <span className="patient-info-item"><span className="label">First Name:</span> <span className="value">{patientInfo.FirstName}</span></span>
          <span className="patient-info-item"><span className="label">Patient SSN:</span> <span className="value">{formatSSN(patientInfo.PatientSSN)}</span></span>
          <span className="patient-info-item"><span className="label">Patient DOB :</span> <span className="value">{formatDOB(patientInfo.PatientDOB)}</span></span>
          <span className="patient-info-item"><span className="label">Patient Cell:</span> <span className="value">{formatCell(patientInfo.PatientCell)}</span></span>
          <span className="patient-info-item"><span className="label">PSFS Appt.:</span> <span className="value">{
            !patientInfo.ts_Appointment ||
              patientInfo.ts_Appointment === 'Unknown' ||
              !moment(patientInfo.ts_Appointment).isValid()
              ? 'Unknown'
              : moment(patientInfo.ts_Appointment).format('MM/DD/YYYY HH:mm')
          }</span></span>
        </div>
        {/* Right side - Status and Step */}
        <div className="patient-info-row m-1" style={{ marginLeft: 'auto' }}>
          {/* <span className="patient-info-item"><span className="label">Status:</span> <span className="value" style={{ whiteSpace: 'nowrap' }}>{form.fk_Status === -1
            ? 'Pending'
            :
            psfsElements?.PSFSStatus?.find((c: { _key: any; }) => c._key === form.fk_Status)
              ?.FriendlyName || 'Unknown'}</span></span> */}
          <span className="patient-info-item"><span className="label">Step:</span> <span className="value" style={{ whiteSpace: 'nowrap' }}>{form.fk_Step === -1
            ? 'Pending'
            : (() => {
              const steps = psfsElements?.PSFSStep || [];
              if (!Array.isArray(steps) || steps.length === 0) return 'Unknown';
              const maxStep = Math.max(...steps.map((c: { StepNo: number }) => c.StepNo));
              const stepNo = stepManuallyChanged
                ? form.fk_Step
                // : Math.min(form.fk_Step + 1, maxStep);
                : form.fk_Step;
              const stepObj = steps.find((c: { StepNo: number }) => c.StepNo === stepNo);
              return stepObj?.FriendlyName || 'Unknown';
            })()}</span></span>
        </div>
      </div>
      <hr />
    </div>
  )
};

export default PatientHeader;
